// libs
import { styled } from '@nykaa/ui-components';

export const ViewAllContainer = styled.span`
  text-decoration: none;
  display: flex;
  flex: none;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondary};
  ${({ theme }) => theme.typography.buttonMedium};
  margin-left: ${({ theme }) => theme.spacing.spacing40};
`;

export const Title = styled.p`
  margin: 0;
`;
